import { render, staticRenderFns } from "./AuthorizationModal.vue?vue&type=template&id=43dbacbe&scoped=true"
import script from "./AuthorizationModal.vue?vue&type=script&lang=ts"
export * from "./AuthorizationModal.vue?vue&type=script&lang=ts"
import style0 from "./AuthorizationModal.vue?vue&type=style&index=0&id=43dbacbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dbacbe",
  null
  
)

export default component.exports